import { HttpClient } from '@angular/common/http';
// import { HttpParams } from '@angular/common/http';
// import { Injectable, inject } from '@angular/core';
// import { AngularFireAuth } from '@angular/fire/compat/auth';

import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
// import { IdTokenResult } from '@angular/fire/auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';

import { environment } from '@environments/environment';
import {
  concatAll,
  // defer,
  from,
  // lastValueFrom,
  map,
  mergeMap,
  Observable,
  of,
  // pipe,
  Subject,
  // tap,
  // catchError,
} from 'rxjs';
// import { isNullOrUndefined } from '../shared/utils';
import { isNullOrUndefined } from '@app/shared/utils';
import { Router } from '@angular/router';

// HttpParams

export type httpQueryParams = {
  [key: string]: string | number | boolean | string[] | number[] | boolean[];
};

export type PaginatedResponse<T> = {
  count: number;
  page_size: number;
  pages: number;
  links: {
    next: string | null;
    previous: string | null;
  };
  results: T[];

  // "count": 4,
  //   "page_size": 1,
  //   "pages": 4,
  //   "links": {
  //       "next": "http://localhost:9577/api/tasks/30/comments/?page=2&page_size=1",
  //       "previous": null
  //   },
};

export class MissingTokenError extends Error {
  constructor(message?: string | undefined) {
    super(message); // (1)
    this.name = 'ValidationError'; // (2)
  }
}

export interface RecursiveInterface<T = any> {
  completed: boolean;
  results: T[];
  actual_page: number;
  tot_pages: number;
  count: number;
}

var DEFAULT_TIMEOUT = 10000;

@Injectable({
  providedIn: 'root',
})
export class BaseAuthenticatedService {
  public router: Router;
  constructor(public auth: AngularFireAuth, public httpClient: HttpClient) {
    this.router = inject(Router);
  }

  getAuthHeaders(
    headers: { [key: string]: string } = {
      'Content-Type': 'application/json',
    }
  ): Observable<HttpHeaders> {
    let h = {
      'Content-Type': 'application/json',
      // Authorization: 'my-auth-token',
      ...headers,
    };
    let _headers = new HttpHeaders(h);
    if (_headers.get('Content-Type') === 'multipart/form-data') {
      console.log('multipart/form-data');
      _headers = _headers.delete('Content-Type');
    }
    let idToken = localStorage.getItem('FToken');
    if (!idToken) {
      // throw new Error('Un');
      console.error('Missing FToken');
      this.router.navigate(['/auth/login'], {
        queryParams: { next: this.router.url },
      });
      throw new MissingTokenError();
    }
    let tokenExpirationTime = localStorage.getItem('FtokenExpirationTime');
    if (!tokenExpirationTime || tokenExpirationTime === null) {
      console.error('Missing FtokenExpirationTime');
      // throw new Error('Un');
      this.router.navigate(['/auth/login'], {
        queryParams: { next: this.router.url },
      });

      throw new MissingTokenError();
    }
    let _now = new Date();
    let now = _now.getTime() - 1000;
    let _expiracy = new Date(tokenExpirationTime);
    let expiracy = _expiracy.getTime();
    // console.log(_now, 'now', now);
    // console.log(_expiracy, 'expiracy', expiracy);
    if (expiracy > now) {
      _headers = _headers.set('Authorization', 'FToken ' + idToken);
      return of(_headers);
    } else {
      // return
      // debugger;
      // setTimeout(() => {
      return from(this.auth.user).pipe(
        map((user) => {
          if (!user) {
            throw new MissingTokenError();
          }
          const idTokenResult = user?.getIdTokenResult();
          if (!idTokenResult || idTokenResult === undefined) {
            throw new MissingTokenError();
          }
          return idTokenResult;
          // return from(idTokenResult);
        }),

        // return this.auth.credential.pipe(
        // map((userCredential) => {
        //   if (!userCredential) {
        //     throw new MissingTokenError();
        //   }
        //   const idTokenResult = userCredential.user?.getIdTokenResult();
        //   if (!idTokenResult || idTokenResult === undefined) {
        //     throw new MissingTokenError();
        //   }
        //   return idTokenResult;
        //   // return from(idTokenResult);
        // }),
        mergeMap((idTokenResult) => {
          return from(idTokenResult);
        }),
        // map((idTokenResult) => {
        //   return from(idTokenResult);
        // }),
        // map(
        //   (idTokenResult) => {
        //     idTokenResult.
        //   }
        // )

        // )
        // .pipe(
        map((idTokenResult) => {
          localStorage.setItem('FToken', idTokenResult.token);
          localStorage.setItem(
            'FtokenExpirationTime',
            idTokenResult.expirationTime
          );
          _headers = _headers.set(
            'Authorization',
            'FToken ' + idTokenResult.token
          );
          return of(_headers);
        }),
        concatAll()
      );
      // debugger;
      // let userCredential = await lastValueFrom(userCredential$);
      // }, 500);
      // const userCredential$ = this.auth.credential;
      // let userCredential = await lastValueFrom(userCredential$);

      // // let userCredential = await this.auth.credential.toPromise();
      // if (!userCredential) {
      //   throw new MissingTokenError();
      // }

      // const idTokenResult$ = userCredential.user?.getIdTokenResult();
      // if (!idTokenResult$ || idTokenResult$ === undefined) {
      //   throw new MissingTokenError();
      // }
      // let idTokenResult = await idTokenResult$;
      // // let idTokenResult = await userCredential.user?.getIdTokenResult();
      // if (!idTokenResult) {
      //   throw new MissingTokenError();
      // }
      // localStorage.setItem('FToken', idTokenResult.token);
      // localStorage.setItem(
      //   'FtokenExpirationTime',
      //   idTokenResult.expirationTime
      // );
      // headers = headers.set('Authorization', 'FToken ' + idTokenResult.token);
      // return headers;
      // .pipe(
      //   map((userCredential) => {
      //     let idTokenResult = defer(() => {
      //       return promise;
      //     });
      //     if (!idTokenResult) {
      //       throw new MissingTokenError();
      //     }
      //     return idTokenResult.pipe(
      //       tap((r) => {
      //         return r;
      //       }),
      //       map((r) => {
      //       })
      //     );
      //   })
      // );
    }
    // localStorage.setItem(
    //   'FtokenExpirationTime',
    //   idTokenResult.expirationTime
    // );
  }

  getOptions(
    params: httpQueryParams = {},
    option_headers: { [key: string]: string } = {
      'Content-Type': 'application/json',
    }
  ) {
    let headers = this.getAuthHeaders(option_headers);
    return headers.pipe(
      map((_headers) => {
        return {
          headers: _headers,
          params: params,
        };
      })
      // concatAll()
    );
    // map((headers) => {
    // })
    // );
    // return
  }

  getUrl(path: string): string {
    const backendDomain = environment.backendDomain;
    return `${backendDomain}/${path}`;
  }

  protected getList<T>(
    path: string,
    params: httpQueryParams = {}
  ): Observable<PaginatedResponse<T>> {
    let url = this.getUrl(path);
    return this.getOptions(params).pipe(
      map((option) => {
        return this.httpClient.get<PaginatedResponse<T>>(url, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return
  }

  protected getDetail<T>(
    path: string,
    params: httpQueryParams = {}
  ): Observable<T> {
    let url = this.getUrl(path);

    return this.getOptions(params).pipe(
      map((option) => {
        return this.httpClient.get<T>(url, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return this.httpClient.get<T>(url, option);
  }

  protected create<T>(
    path: string,
    params: httpQueryParams = {},
    data: { [key: string]: any } | FormData
  ): Observable<T> {
    let url = this.getUrl(path);
    let option$ = undefined;
    if (data instanceof FormData) {
      option$ = this.getOptions(params, {
        'Content-Type': 'multipart/form-data',
      });
    } else {
      option$ = this.getOptions(params);
    }
    // option$ = this.getOptions(params);
    return option$.pipe(
      map((option) => {
        return this.httpClient.post<T>(url, data, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return this.httpClient.get<T>(url, option);
  }

  protected update<T>(
    path: string,
    params: httpQueryParams = {},
    data: { [key: string]: any } | FormData
  ): Observable<T> {
    let url = this.getUrl(path);
    let option$ = undefined;
    if (data instanceof FormData) {
      option$ = this.getOptions(params, {
        'Content-Type': 'multipart/form-data',
      });
    } else {
      option$ = this.getOptions(params);
    }
    // option$ = this.getOptions(params);
    return option$.pipe(
      map((option) => {
        return this.httpClient.put<T>(url, data, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return this.httpClient.get<T>(url, option);
  }

  protected partialUpdate<T>(
    path: string,
    params: httpQueryParams = {},
    data: { [key: string]: any } | FormData
  ): Observable<T> {
    let url = this.getUrl(path);
    let option$ = undefined;
    if (data instanceof FormData) {
      option$ = this.getOptions(params, {
        'Content-Type': 'multipart/form-data',
      });
    } else {
      option$ = this.getOptions(params);
    }
    // option$ = this.getOptions(params);
    return option$.pipe(
      map((option) => {
        return this.httpClient.patch<T>(url, data, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return this.httpClient.get<T>(url, option);
  }

  // ----------------------------------------------------------------------------
  // ----------------------------------------------------------------------------
  // --------------------------normal http verbs---------------------------------
  // ----------------------------------------------------------------------------
  // ----------------------------------------------------------------------------

  protected get<T>(
    path: string,
    params: httpQueryParams = {},
    timeout: number = DEFAULT_TIMEOUT
  ): Observable<T> {
    let url = this.getUrl(path);

    return this.getOptions(params).pipe(
      map((option) => {
        return this.httpClient.get<T>(url, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return this.httpClient.get<T>(url, option);
  }

  private update_param_with_next_page(
    params: { [key: string]: number | string | boolean } | httpQueryParams
  ): number {
    // return params['page']++;

    try {
      if (Array.isArray(params['page'])) {
        return 1;
      } else {
        let p = params['page'] as string;
        let new_page = parseInt(p, 10) + 1;
        params['page'] = new_page;
        return new_page;
      }
    } catch (error) {
      return 1;
    }
  }

  private get_current_page(
    params: { [key: string]: number | string | boolean } | httpQueryParams
  ): number {
    try {
      if (Array.isArray(params['page'])) {
        return 1;
      } else {
        return parseInt(params['page'] as string, 10);
      }
    } catch (error) {
      return 1;
    }
  }

  private getDataByPage<T>(
    path: string,
    params: { [key: string]: number | string | boolean } | httpQueryParams = {},
    results: T[],
    subject: Subject<RecursiveInterface<T>>,
    page_size: number,
    timeout: number = DEFAULT_TIMEOUT
  ) {
    // let url = this.getUrl(path);
    this.get<PaginatedResponse<T>>(path, params, timeout).subscribe({
      next: (response) => {
        results = (results || []).concat(response['results']);

        if (this.get_current_page(params) < response.pages) {
          subject.next({
            completed: false,
            results: results,
            actual_page: this.get_current_page(params),
            tot_pages: response.pages,
            count: response.count,
          });
          this.update_param_with_next_page(params);
          this.getDataByPage(
            path,
            params,
            results,
            subject,
            page_size,
            timeout
          );
        } else {
          subject.next({
            completed: true,
            results: results,
            actual_page: this.get_current_page(params),
            tot_pages: response.pages,
            count: response.count,
          });
        }
      },
      error: (error) => {
        subject.error('error');
      },
    });
  }

  public getRecursivePage<T>(
    path: string,
    params: { [key: string]: number | string | boolean } | httpQueryParams = {},
    // headers?: HttpHeaders,
    timeout: number = DEFAULT_TIMEOUT
  ): Subject<RecursiveInterface<T>> {
    const subject: Subject<RecursiveInterface<T>> = new Subject();

    // let url = this.getUrl(path);

    if (isNullOrUndefined(params['page'])) {
      params['page'] = 1;
    }
    // debugger;
    this.get<PaginatedResponse<T>>(path, params, timeout).subscribe({
      next: (response) => {
        if (response.count === 0) {
          subject.next({
            completed: true,
            results: [],
            actual_page: 1,
            tot_pages: 1,
            count: 0,
          });
        } else if (response.pages === 1) {
          subject.next({
            completed: true,
            results: response.results,
            actual_page: 1,
            tot_pages: 1,
            count: response.count,
          });
        } else {
          const results = response.results;

          this.update_param_with_next_page(params);
          this.getDataByPage(path, params, results, subject, timeout);
        }
      },
      error: (error) => {
        subject.error('error');
      },
    });
    return subject;
  }

  protected post<T>(
    path: string,
    params: httpQueryParams = {},
    data: { [key: string]: any }
  ): Observable<T> {
    let url = this.getUrl(path);

    return this.getOptions(params).pipe(
      map((option) => {
        return this.httpClient.post<T>(url, data, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return this.httpClient.get<T>(url, option);
  }

  protected put<T>(
    path: string,
    params: httpQueryParams = {},
    data: { [key: string]: any }
  ): Observable<T> {
    let url = this.getUrl(path);

    return this.getOptions(params).pipe(
      map((option) => {
        return this.httpClient.put<T>(url, data, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return this.httpClient.get<T>(url, option);
  }

  protected patch<T>(
    path: string,
    params: httpQueryParams = {},
    data: { [key: string]: any }
  ): Observable<T> {
    let url = this.getUrl(path);

    return this.getOptions(params).pipe(
      map((option) => {
        return this.httpClient.patch<T>(url, data, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return this.httpClient.get<T>(url, option);
  }

  protected delete<T>(
    path: string,
    params: httpQueryParams = {}
    // data: { [key: string]: any }
  ): Observable<T> {
    let url = this.getUrl(path);

    return this.getOptions(params).pipe(
      map((option) => {
        return this.httpClient.delete<T>(url, option);
      }),
      concatAll()
    );
    // let option = this.getOptions(params);
    // return this.httpClient.get<T>(url, option);
  }
}
